import { useEffect } from "react";
import { Theme, LOCAL_STORAGE_THEME_KEY } from "shared-types";
import { useLocalStorage } from "usehooks-ts";

export function useTailwindTheme(): [Theme, () => void] {
  const [theme, setTheme] = useLocalStorage<Theme>(
    LOCAL_STORAGE_THEME_KEY,
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? Theme.Dark
      : Theme.Light
  );

  useEffect(() => {
    const root = document.documentElement;

    if (theme === Theme.Dark) {
      root.classList.add(Theme.Dark);
    } else {
      root.classList.remove(Theme.Dark);
    }
    
    setTheme(theme);
  }, [theme]);

  return [
    theme,
    () => setTheme((prev) => (prev === Theme.Dark ? Theme.Light : Theme.Dark)),
  ];
}
